import { ParentSize } from '@visx/responsive';
import StackedAreaSparkline from '@/ui/components/DataVis/StackedAreaSparkline';
import { shapeTimeSeries } from 'utils/hooks/sourceDataShaping';
import { theme } from 'utils/theme';
import type { SparklineProps } from '../types';

const HEIGHT = 124;

const PLATFORM_SERIES = [
    { id: 'google', color: theme.google_blue_100 },
    { id: 'tiktok', color: theme.tiktok_pink_100 },
    { id: 'instagram', color: theme.instagram_orange_100 },
];

const Sparkline = ({ timeSeries }: SparklineProps) => {
    const series = PLATFORM_SERIES.map(({ id, color }) => ({
        id,
        color,
        timeSeries: shapeTimeSeries(timeSeries?.[id] ?? []),
    })).filter(({ timeSeries: t }) => Array.isArray(t) && t.length > 1);

    if (series.length === 0) return null;

    return (
        <div className="w-full" style={{ height: HEIGHT }}>
            <ParentSize>
                {({ width, height }) =>
                    width > 0 && height > 0 ? (
                        <StackedAreaSparkline
                            series={series}
                            width={width}
                            height={height}
                        />
                    ) : null
                }
            </ParentSize>
        </div>
    );
};

export default Sparkline;
